import React, { useEffect } from "react";
import Body from "@appsinti/stats-frontend/home/components/Body";
import LineChart from "../../components/charts/line";
import BarChart from "../../components/charts/bar";
import { useData } from "../../data";
import { BG_DARK } from "@etiquette-ui/colors";
import { Ring } from "@uiball/loaders";
import IChartData from "../../../interfaces/IChartData";
import MultipleCharts from "./components/MultipleCharts";

const Cash: React.FC = () => {
  const { cash, fetchCash } = useData();

  useEffect(() => {
    fetchCash();
  }, []);

  const cashParent = (cash ?? []).find(item => item?.key === 'monthlySalesNMonths');

  return cash ? (
    <Body>
      {cash?.map((graph: IChartData | null, index: React.Key | null | undefined) => {
        if (!graph) return null;

        if (graph.type === "line") {
          return (
            <LineChart
              key={index}
              dataObject={graph}
            />
          );
        }

        if (graph.type === "bar") {
          return (
            <BarChart
              key={index}
              dataObject={graph}
            />
          );
        }

        if (graph.type === "multiple_bar") {
          return (
            <MultipleCharts
              key={index}
              dataObject={graph}
              cash={cashParent}
            >
              {graph.datasets.map((dataset, idx) => (
                dataset ? (
                  <BarChart
                    key={idx}
                    dataObject={dataset as unknown as IChartData}
                  />
                ) : null
              ))}
            </MultipleCharts>
          );
        }

        return null;
      })}
    </Body>
  ) : (
    <Body style={{ display: "flex", justifyContent: "center" }}>
      <Ring color={BG_DARK} size={50} />
    </Body>
  );
};
export default Cash;
